import React from 'react'
import { HeaderGlobal, Breadcrumb } from 'src/components';
import { ILPageNotFound } from 'src/assets/image';

const NotFound = ({ match, crumbs }) => {
    return (
        <div className="site-main">
            <HeaderGlobal />
            <section className="ttm-row aboutus-section clearfix">
                <div className="container-xl mt-4 res-767-mt-0">

                    {/* BREADCUMB */}
                    {/* <Breadcrumb crumbs={crumbs} /> */}
                    {/* BREADCUMB */}

                    <div className="row">
                        <div className="col-md-12">
                            <center>
                                <img src={ILPageNotFound} className={'img-fluid'} style={{ width: 500 }} /> <br />
                                <span>Halaman tidak ditemukan!</span>
                            </center>
                        </div>
                    </div>

                </div>
            </section>

        </div>
    )
}

export default NotFound
